// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header[data-v-c2762910]{font-size:1.1rem;line-height:1.5;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-weight:400}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
